import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { InfopopupModule } from '../infopopup/infopopup.module'; // Verify this module is correctly implemented and exported

import { MegaMenuModule } from '../mega-menu/mega-menu.module';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { SuperPlaceholderDirective } from '../../directive/super-placeholder.directive';
import { RouterModule } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';



@NgModule({
  declarations: [HeaderComponent,SuperPlaceholderDirective],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MegaMenuModule,
    InfopopupModule,
    ToastModule,
    SidebarModule,
    BadgeModule,
    DialogModule,
    ButtonModule,
    
  ],
  exports:[HeaderComponent,SuperPlaceholderDirective]
})
export class HeaderModule { }
